import {BackendLanguageTag} from '../../backend/enums/backend-language-tag';
import {LanguageCode} from '../../enums/language-code';

/**
 * Get the backend language tag from the language set in the browser.
 */
export const getBackendLanguageFromBrowserLanguage = (): BackendLanguageTag | undefined => {
  // Backend language
  let languageCode: BackendLanguageTag | undefined;

  // Browser language code (Example: 'pt', 'en', 'es', etc)
  const browserLanguageCode: string | null = navigator.language
    ? navigator.language.split('-')[0]
    : null;

  // Search for the language
  switch (browserLanguageCode) {
    case LanguageCode.pt:
      languageCode = BackendLanguageTag.ptPT;
      break;
    case LanguageCode.en:
      languageCode = BackendLanguageTag.enUS;
      break;
    case LanguageCode.es:
      languageCode = BackendLanguageTag.esES;
      break;
    case LanguageCode.br:
      languageCode = BackendLanguageTag.ptBR;
      break;
    case LanguageCode.gl:
      languageCode = BackendLanguageTag.glES;
      break;
    default:
      languageCode = undefined;
      break;
  }

  return languageCode;
};
